const state = () => {
    return {
      fitoProducts:[],
      fitoProductsLight:[]
    }
  }
  
  export default state;
  